var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('a',{attrs:{"href":"https://www.facebook.com/oz4x4europe/","target":"_blank"}},[_c('img',{staticClass:"icon-item",attrs:{"src":require("./../../../../assets/facebook.png"),"alt":"Facebook"}})])])
}]

export { render, staticRenderFns }